import React, { Fragment } from "react";
import { AlignCenter } from "react-feather";
import { Link } from "react-router-dom";
import { Container, Row } from "reactstrap";
import { H5, Image, Btn } from "../../../AbstractElements";
// import { WE_ARE_COMING_SOON } from '../../../Constant';
import HeaderLP from "../../Navbar/HeaderLP";
// import { LogIn } from 'react-feather';

const ComingSimple = () => {
  return (
    <Fragment>
      <div className="comingsoon-bgimg landing-page">
        <div className="page-wrapper compact-wrapper" id="pageWrapper">
          <HeaderLP />
          {/* <!-- Page Body Start--> */}
          <Container fluid={true} className="p-0">
            <div className="comingsoon">
              <div className="comingsoon-inner text">
                {/* <Image attrImage={{ className: 'img-fluid', src: `${imgg}`, alt: '' }} /> */}
                <H5>SISTEM</H5>
                <H5>INFORMASI</H5>
                <H5>KEUANGAN</H5>
                <Link
                  to={`${process.env.PUBLIC_URL}/login`}
                  className="btn btn-primary w-100"
                >
                  Masuk
                </Link>
                {/* <Btn attrBtn={{color:"primary"}} >Masuk</Btn> */}
              </div>
              <div className="row">
                <div className="col-xl-4 "></div>
                <div class="col-xl-8 p-0">
                  <Image
                    attrImage={{
                      className: "img-fluid bg-img-cover",
                      src: `${require("../../../assets/images/teamwork.png")}`,
                      alt: "landingpage",
                    }}
                  />
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
      {/* <Row>
            <div className="bg-white" >
                <Image attrImage={{ className: 'img-fluid', src: `${imgg}`, alt: '' }} />
              </div>
            </Row> */}
    </Fragment>
  );
};

export default ComingSimple;
